import { render, staticRenderFns } from "./purchase_return_edit.vue?vue&type=template&id=4f22c9d0&scoped=true"
import script from "./purchase_return_edit.vue?vue&type=script&lang=js"
export * from "./purchase_return_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f22c9d0",
  null
  
)

export default component.exports